import {clickEvent} from "../../../webpack/modules/events";
import {slideDown, slideUp, slideUpBySelector} from "../../../webpack/modules/element-visibility";
import {post} from "../../../webpack/modules/ajax";

clickEvent('header .header-dropdown[data-type="user"]', false, async function(element) {
    let container = element.closest('.user');
    let dropdown = container.querySelector('.content');
    let formRendered = !dropdown.querySelector('.dropdown-loader');
    let isShowed = (dropdown.offsetWidth && dropdown.offsetHeight);

    if (!isShowed) {
        showDropdown(dropdown);
        if (!formRendered) {
            dropdown.innerHTML = await renderDropdown('user');
            window.facebookSignWithInit();
            google.accounts.id.renderButton(
                dropdown.querySelector('.g_id_signin'),
                { type: "icon", size: "large", theme: "outline" }
            );
        }
    }
    else hideDropdown(dropdown);
});

function onOutsideClick(e)
{
    if (e.target.closest('header .user')) return;
    hideDropdown(document.querySelector('header .user .content'));
}

function renderDropdown(type)
{
    return new Promise(resolve => {
        post(
            '/ajax/website/header/render-dropdown',
            {
                type: type
            },
            function (response) {
                resolve(response.view);
            }
        );
    });
}

function showDropdown(dropdown)
{
    slideUpBySelector('.header-dropdown .content', 200, function() {
        slideDown(dropdown);
        document.addEventListener('click', onOutsideClick);
    });
}

function hideDropdown(dropdown)
{
    document.removeEventListener('click', onOutsideClick);
    slideUp(dropdown);
}
